<template>
  <div class="base-contract">
    <div class="hd ly-card">
      <el-button class="fl" @click="openDigFrom(true)" type="primary">新增</el-button>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      :statusAction="statusAction"
      ref="lyTable"
      class="ly-card"
    >
      <template v-slot:activate_status="row">
        <el-button
          @click="statusRow(row, row.activate_status)"
          type="text"
          :class="row.activate_status && 'el-button--danger'"
          size="mini"
          >{{ row.activate_status ? '禁用' : '启用' }}</el-button
        >
      </template>
      <template v-slot:action="row">
        <template>
          <el-button @click="editRow(row)" type="primary" size="mini">编辑</el-button>
          <el-button @click="delRow(row)" type="danger" size="mini">删除</el-button>
        </template>
      </template>
    </ly-table>
    <el-dialog
      :title="`${defaultFormItem.id ? '修改' : '新增'}合同类型`"
      :visible.sync="dialogVisible"
      width="500px"
      @opened="openEvent"
    >
      <ly-form :defaultFormItem="defaultFormItem" :formConfig="formConfig" :formKeys="formKeys" ref="lyForm"></ly-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addContract">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from 'element-ui';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import { base } from '@/api';

export default {
  name: 'baseContract',
  components: {
    LyTable,
    LyForm,
    ElDialog: Dialog
  },
  data() {
    return {
      dialogVisible: false,
      formKeys: {
        name: {
          type: 'text',
          label: '类型名称',
          placeholder: '请填写类型名称',
          rules: [
            {
              required: true,
              message: '请填写类型名称',
              trigger: 'blur'
            }
          ]
        },
        remarks: {
          type: 'text',
          label: '备注信息',
          placeholder: '请填写备注信息',
          options: {
            type: 'textarea',
            rows: 4
          }
        }
      },
      defaultFormItem: {},
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24,
        inline: false
      },
      searchFormData: {
        year: ''
      },
      tableHeader: [
        {
          value: 'name',
          name: '名称'
        },
        {
          value: 'remarks',
          name: '备注'
        },
        {
          value: 'activate_status',
          name: '状态',
          editOptions: {
            type: 'status'
          }
        },
        {
          value: 'action',
          name: '操作'
        }
      ],
      getTableData: base.getContract,
      options: [],
      statusAction: [row => base.activateContract({ contract_type_id: row.id }), row => base.deactivateContract({ contract_type_id: row.id })]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.search();
    },
    openEvent() {
      this.$refs.lyForm.$refs.lyForm.clearValidate();
    },
    search() {
      this.$refs.lyTable.setData();
    },
    openDigFrom(isAdd) {
      this.dialogVisible = true;
      if (isAdd) {
        this.defaultFormItem = { status: true };
      }
    },
    async addContract() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        let res = null;
        if (this.defaultFormItem.id) {
          // 修改
          res = await base.controlContract({
            methold: 'put',
            id: this.defaultFormItem.id,
            params: data
          });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '修改成功');
        } else {
          // 新增
          res = await base.addContract({
            params: data,
            methold: 'post'
          });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '新增成功');
        }
        if (res) {
          this.$refs.lyTable.setData();
          this.dialogVisible = false;
        }
      }
    },
    delRow(row) {
      this.$confirm('确认删除？')
        .then(() => {
          base
            .controlContract({
              methold: 'delete',
              id: row.id
            })
            .then(res => {
              this.search();
              this.$store.dispatch('msg/showMsg', res.msg || '删除成功');
            });
        })
        .catch(() => {});
    },
    editRow(row) {
      this.defaultFormItem = { ...row };
      this.openDigFrom();
    }
  }
};
</script>

<style lang="less">
.base-contract {
  .hd {
    overflow: hidden;
  }
}
</style>
